import ModalSlot, { slot } from "../../components/ModalSlot"

const image = "https://assets.swoogo.com/uploads/full/3013856-651db0e6a7e45.png"

const links = [...slot(10, {space: 7.4}), {
    width: "28.4%",
    height: "4.8%",
    top: "88.7%",
    left: "34.8%"
}]

const slots = [
    {
        href: "https://www.isflive.org/s/article/Leadership-Insights-Unlocking-the-business-value-of-security", 
        label: "Leadership Insights: Unlocking the business value of security"
    },
    {
        href: "https://www.isflive.org/s/article/Human-Centred-Security-Positively-influencing-security-behaviour?topicId=0TO0J00000055yTWAQ",
        label: "Human Centred Security: Positively influencing security behaviour"
    },
    {
        href: "https://www.isflive.org/s/article/Human-Centred-Security-Addressing-psychological-vulnerabilities",
        label: "Human Centred Security: Addressing psychological vulnerabilities"
    },
    {
        href: "https://www.isflive.org/s/article/Nurturing-Security-Governance-Becoming-effective-through-engagement",
        label: "Nurturing Security Governance: Becoming effective through engagement"
    },
    {
        href: "https://www.isflive.org/s/article/DOC-6311",
        label: "Engaging with the Board: Balancing cyber risk and reward"
    },
    {
        href: "https://www.isflive.org/s/article/Becoming-a-next-generation-CISO?topicId=0TO0J0000009AO3WAM",
        label: "Becoming a next generation CISO"
    },
    {
        href: "https://www.isflive.org/s/article/Information-Security-in-Mergers-and-Acquisitions",
        label: "Information-Security-in-Mergers-and-Acquisitions".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/Extinction-Level-Attacks-A-survival-guide-Report?topicId=0TO0J0000001zfJWAQ",
        label: "Extinction-Level-Attacks:-A-survival-guide-Report".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/DOC-10973?topicId=0TO6M0000005BNUWA2",
        label: "From Promoting Awareness to Embedding Behaviours: Secure by choice, not by chance"
    },
    {
        href: "https://www.isflive.org/s/article/DOC-24123",
        label: "Delivering an Effective Cyber Security Exercise"
    },
    {
        href: "https://www.isflive.org/s/knowledge-library",
        label: "Visit the ISF Library"
    }
]

export default () => <ModalSlot img={image} links={links} slots={slots} />